<template>
  <div>
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else class="pro-rel-lb-uti">
      <div class="app-fil-rel-nov">
        <table>
          <tr class="n-col-2">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'seletor-data'"
              :cpntNome="''"
              :cpntTodos="''"
              :cpntValue="filtros.dat"
              @UPDATE_VALUE_FILTRO="(value) => { proRelLucroBrutoAtualizarFiltro(value, 'dat') }"
              ref="dat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="false"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return proRelLucroBrutoMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelLucroBrutoAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr :class="'n-col-' + demRelPorContatoContarColunasLinha1">
            <td v-if="permissoes.vei === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
              :cpntNome="'Veículo'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.vei"
              :cpntNenhum="true"

              :cpntRouter="'/veiculo/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelLucroBrutoAtualizarFiltro(value, 'vei') }"
              ref="vei"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.pet === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
              :cpntNome="'Pet'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pet"
              :cpntNenhum="true"

              :cpntRouter="'/pet/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelLucroBrutoAtualizarFiltro(value, 'pet') }"
              ref="pet"
              ></App-Filtro-Relatorio>
            </td>
            <td :colspan="(4 - demRelPorContatoContarColunasLinha1)">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
              :cpntNome="'Contatos'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.con"
              :cpntNenhum="false"

              :cpntRouter="'/contato/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { proRelLucroBrutoAtualizarFiltro(value, 'con') }"
              ref="con"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- SETA O BOTÃO PESQUISAR -->
    <div class="pro-rel-lb-uti-botao">
      <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { proRelLucroBrutoPesquisar() }">Pesquisar</App-Button>
    </div>

    <!-- <div class="dem-rel-mais-uti-res" v-if="pesquisa !== null && pesquisa !== 'carregando'"> -->
    <div class="dem-rel-mais-uti-res" v-if="router !== ''">          
      <App-Tabela
      :cpntStatus="statusTabela"
      :cpntBotaoExportar="exportar"
      :cpntApiRouter="router"
      :cpntApiMethods="method"
      :cpntColuna="colunas"
      :cpntLinha="linhas"
      :cpntMostrarMper="true"
      :cpntApiTabPerOrder="mPerOrder"
      :cpntSetarValores="proRelLucroBrutoSetarLinhas"
      :cpntApiTabPerRpp="null"
      :cpntApiTabPerFiltros="false"
      :cpntApiTabPer="mPer"
      :cpntBotaoImprimir="true"
      :cpntApiBuscaComplementar="proRelLucroBrutoSetarTotais"
      :cpntApiMontarQueryGet="proRelLucroBrutoMontarQueryGet"
      :cpntApiEstruturaQueryGet="estruturaQueryGet"
      ref="tabela">
      <!-- @BUSCAR="proRelLucroBrutoPesquisar" -->
      <template v-slot:titulo v-if="[ '', null, undefined ].indexOf($store.state.mPer[mPer]) === -1">
        <span :key="JSON.stringify($store.state.mPer[mPer])">
          <span>&nbsp;Ordenado por:&nbsp;</span>
          <b class='destaque' v-html="mPerOrder.filter(item => item.id === $store.state.mPer[mPer].order)[0].nome"></b>
        </span>
      </template>

      <template v-slot:col_id_pro_nome="{ linha }">
        <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { proRelLucroBrutoAbrirCadastro(linha.id_pro) }'>
          <span v-html="linha.id_pro_nome"></span>
        </App-Button>
      </template>

      <template v-slot:col_custo_total="{ linha }">
        <span v-html="linha._custo_total"></span>
        <App-Button v-if="linha.flagTotal !== true" :data-time="time" style="padding: 2px 3px;" :cpntIcone="'info'" title="Clique aqui para as informações do custo" @onClick="() => { detalheCusto = linha } " ref="btDialogRel"></App-Button>
      </template>

      <template v-slot:col_lucro_bruto="{ linha }">
        <div v-html="linha.lucro_bruto"></div>
        <div v-html="linha._markup_por"></div>
      </template>
      </App-Tabela>
    </div>

    <App-Relatorio-Detalhe-Custo v-if="detalheCusto !== null"
    :cpntDetalhe="detalheCusto"
    :cpntFecharFormulario="() => { detalheCusto = null }"
    ></App-Relatorio-Detalhe-Custo>
  </div>
</template>

<style scoped>
.pro-rel-lb-uti-botao {
  text-align: center;
  margin: 10px;
  padding: 0px 20px
}
.dem-rel-mais-uti-res {
  margin-top: 20px;
}
</style>

<style>
  .pro-rel-lb-uti > .app-fil-rel > div > div > table {
    max-width: 500px;
    margin: 0px auto;
  }

  .dem-rel-mais-uti-res > table > tbody > tr.linha-total > td {
    font-weight: bold;
  }
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_custo_total {
    -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
    -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
    box-shadow: inset 0px 1px 0px 0px #ffffff;
    background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f7c6c6), color-stop(1, #ecc5bd) );
    background: -moz-linear-gradient( center top, #f7c6c6 5%, #ecc5bd 100% );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7c6c6', endColorstr='#ecc5bd');
    background-color: #f7c6c6;
    text-decoration: none;
  }
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_venda_total {
    -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
    -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
    box-shadow: inset 0px 1px 0px 0px #ffffff;
    background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #cdfacd), color-stop(1, #bdecbd) );
    background: -moz-linear-gradient( center top, #cdfacd 5%, #bdecbd 100% );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cdfacd', endColorstr='#bdecbd');
    background-color: #cdfacd;
    text-decoration: none;
  }
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_lucro_bruto {
    background-color: #D4E7F1;
    background-image: -moz-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
    background-image: -webkit-gradient(linear, color-stop(0, #EDF5F9), color-stop(1, #D4E7F1));
    background-image: -webkit-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
    background-image: -o-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
    background-image: -ms-linear-gradient(#EDF5F9 0, #D4E7F1 100%);
    background-image: linear-gradient(#EDF5F9 0, #D4E7F1 100%);
  }
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_custo_total,
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_lucro_bruto,
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_venda_total {
    text-align: right;
  }
  .dem-rel-mais-uti-res > table > tbody > tr > td.col_custo_total > div > span > button {
    margin-left: 3px;
  }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        type: Object
      }
      // cpntSetarStatusButton: {
      //   required: true
      // }
    },
    components: {
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Relatorio-Detalhe-Custo': () => import('@/components/produto/relatorios/Relatorio-Detalhe-Custo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        detalheCusto: null,
        statusTabela: '',
        filtros: {
          dem_sta: [ '2' ],
          con: '',
          pet: '',
          vei: '',
          pro: '',
          pro_cat: '',
          pro_mar: '',
          ser: '',
          ser_cat: '',
          dat: '40'
        },
        permissoes: {
          vei: false,
          pet: false,
        },
        mPer: 'ProRelCusLucro',
        exportar: {
          format: [ 'xlsx', 'pdf' ]
        },
        mPerOrder: [
          { id: '0', nome: 'Código Ordem Crescente',       chave: 'id', order: 'desc' },
          { id: '1', nome: 'Código Ordem Decrescente',     chave: 'id', order: 'desc' },
          { id: '2', nome: 'Ordem Alfabética',             chave: 'id', order: 'desc' }
        ],
        pesquisa: null,
        colunas: [
          { mPer: 1, chave: 'id_pro_codigo',         nome: 'Cód.' },
          { mPer: 1, chave: 'id_pro_nome',           nome: 'Nome' },
          { mPer: 1, chave: 'id_pro_id_cat_nome',    nome: 'Categoria' },
          { mPer: 1, chave: 'id_pro_id_mar_nome',    nome: 'Marca' },

          { mPer: 1, chave: 'id_pro_id_uni',         nome: 'Unidade' },
          { mPer: 2, chave: '_qtde_vendida',         nome: 'Qtde. Vendida' },
          { mPer: 2, chave: 'ticket_medio',          nome: 'Ticket médio' },

          { mPer: 2, chave: 'custo_total',           nome: 'Custo Total' },
          { mPer: 2, chave: 'venda_total',           nome: 'Venda Total' },
          { mPer: 2, chave: 'lucro_bruto',           nome: 'Lucro Bruto' }
        ],
        linhas: [],
        router: '',
        method: '',
        estruturaQueryGet: [
          [ /*'type', 'countAll', 'limit', 'field', 'where', 'order', */'SemPaginacao' ]
        ],
        totais: null,
      }
    },
    mounted: function () {
      // VERIFICA SE TEM PERMISSÃO VEICULO
      this.permissoes.vei = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

      // VERIFICA SE TEM PERMISSÃO PET
      this.permissoes.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true

      // INICIA O PROCESSO NA TELA
      this.proRelLucroBrutoIniciar()
    },
    methods: {
      proRelLucroBrutoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelLucroBrutoSetarStatusTabela: function (status) {
        // SETA O STATUS DA TELA
        this.statusTabela = status
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelLucroBrutoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.proRelLucroBrutoSetarStatusGeral('carregando')

        // SETA OS VALORES RECEBIDOS
        if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          for (var index in this.cpntFiltros) {
            if ([ undefined ].indexOf(this.filtros[index]) === -1) {
              this.proRelLucroBrutoAtualizarFiltro(this.cpntFiltros[index], index)
            }
          }
        }

        // VERIFICA SE DEVE REALIZAR O PESQUISAR OU NÃO
        if (this.$route.name === 'produto_relatorio_lucro_bruto_busca') {
          this.proRelLucroBrutoPesquisar()
        }

        // SETA O STATUS DA PAGINA
        this.proRelLucroBrutoSetarStatusGeral('')
      },
      proRelLucroBrutoAtualizarFiltro: function (value, chave) {
        // SETA O STATUS DA TABELA
        // this.proRelLucroBrutoSetarStatusTabela('carregando')

        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
        switch (chave) {
          case 'pro_cat':
          case 'pro_mar':
            this.filtros.pro = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proRelLucroBrutoBuscarValorMper: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.mPer) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mPer]) === -1) {
            success()
          } else {
            this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.mPer, (retorno) => {
              // INICIA O VETOR DE PERSONALIZAÇÃO
              var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }
    
              // VERIFICA SE EXISTE O FILTRO
              retorno.data.filtro = ''
              if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
                // CONVERTE O VALOR RECEBIDO
                retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)
    
                // PEGA O VALOR CONVERTIDO
                retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))
    
                // DELETA O VALOR NÃO UTILIZADO MAIS
                delete retorno.data.id_cg_filtro_j_filtro
              }
    
              // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
              var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1
    
              // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
              if (flag === true) {
                vetor = retorno.data
                vetor.flag = true
              }
    
              // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
              this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.mPer, dados: vetor })
        
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              success()
            }, this.proRelLucroBrutoSetarStatusGeral)
          }
        })
      },
      proRelLucroBrutoMontarWhereFiltro: function () {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O WHERE
        where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

        // VERIFICA SE TEM QUE FILTRAR CATEGORIA
        if (this.filtros.pro_cat !== '') {
          where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
        }

        // VERIFICA SE TEM QUE FILTRAR MARCA
        if (this.filtros.pro_mar !== '') {
          where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      proRelLucroBrutoMontarQueryGet: function (pag, rpp, exportar = null, success = null) {
        // SETA O STATUS DE CARREGANDO
        // this.pesquisa = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        // this.time = new Date().getTime()

        // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        // if (([ '', null, undefined ].indexOf(this.mPer) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mPer]) === -1) === false) {
        //   this.proRelLucroBrutoBuscarValorMper().then(() => { setTimeout(() => { this.proRelLucroBrutoMontarQueryGet() }, 50) }, 0)
        // } else if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat._dataIni === undefined)) {
        //   setTimeout(() => { this.proRelLucroBrutoMontarQueryGet() }, 50)
        // } else {
        //   // REMOVE O FOCUS DE QUALQUER CAMPO
        //   if (document.activeElement !== document.body) {
        //     document.activeElement.blur()
        //   }

        if (success === null) {
          return new Promise((successP) => { this.proRelLucroBrutoMontarQueryGet(pag, rpp, exportar, successP) })
        } else if (this.mPerOrder.length === 0) {
          setTimeout(() => { this.proRelLucroBrutoMontarQueryGet(pag, rpp, exportar, success) }, 50)
        // } else if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat.dataFim === undefined)) {
        //   setTimeout(() => { this.proRelEstMontarQueryGet(pag, rpp, exportar, success) }, 50)
        } else {

          // INICIA A VARIAVEL
          var queryGet = {}

          // SETA O FILTRO PRODUTO
          queryGet.produto = '["t"]'
          if (this.filtros.pro.length >= 1) {
            queryGet.produto = JSON.stringify(this.filtros.pro)
          }

          // SETA O FILTRO CONTATO
          queryGet.cliente = '["t"]'
          if (this.filtros.con.length >= 1) {
            queryGet.cliente = JSON.stringify(this.filtros.con)
          }

          // SETA O FILTRO VEICULO
          queryGet.veiculo = '["t"]'
          if (this.filtros.vei.length >= 1) {
            queryGet.veiculo = JSON.stringify(this.filtros.vei)
          }

          // SETA O FILTRO VEICULO
          queryGet.pet = '["t"]'
          if (this.filtros.pet.length >= 1) {
            queryGet.pet = JSON.stringify(this.filtros.pet)
          }

          // SETA O FILTRO PARA PERIODO
          if (this.filtros.dat === '' || this.filtros.dat.id === '') {
            queryGet.periodo = 'todos'
          } else {
            queryGet.periodo = 'personalizado'
            queryGet.periodo_per1 = this.filtros.dat.dataIni
            queryGet.periodo_per2 = this.filtros.dat.dataFim
          }

          if ([ '', null, undefined ].indexOf(exportar) === -1) {
            queryGet.exportar = { formato: exportar.tipo, pagina: exportar.pagina }
          } else {
            queryGet.paginacao = { pagina: pag, registros_por_pagina: rpp }
          }

          // RETORNA O QUERY MONTADO
          success(queryGet)
        }
      },
      proRelEstTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proRelEstTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proRelLucroBrutoPesquisar: function () {

        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // LIMPA O VALOR DOS TOTAIS
        this.totais = null
        this.linhas = []

        // CHAMA A FUNÇÃO PARA DESTRUIR O GRAFICO
        // this.proRelEstMontarGrafico()

        // SETA O NOME DA ROTA QUE DEVE CHAMAR
        this.router = '/produto/relatorio/lucro-bruto'
        
        // SETA O METHOD DA ROTA QUE DEVE USAR
        this.method = 'POST'

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
          this.proRelEstTabReiniciar()
        } else {
          this.proRelLucroBrutoSetarStatusTabela('')
        }


        // // SETA O STATUS DE CARREGANDO
        // this.pesquisa = 'carregando'

        // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        // this.time = new Date().getTime()

        // // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        // if (([ '', null, undefined ].indexOf(this.mPer) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mPer]) === -1) === false) {
        //   this.proRelLucroBrutoBuscarValorMper().then(() => { setTimeout(() => { this.proRelLucroBrutoPesquisar() }, 50) }, 0)
        // } else if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat._dataIni === undefined)) {
        //   setTimeout(() => { this.proRelLucroBrutoPesquisar() }, 50)
        // } else {
        //   // REMOVE O FOCUS DE QUALQUER CAMPO
        //   if (document.activeElement !== document.body) {
        //     document.activeElement.blur()
        //   }

        //   // INICIA A VARIAVEL
        //   var queryGet = {}

        //   // SETA O FILTRO PRODUTO
        //   queryGet.produto = '["t"]'
        //   if (this.filtros.pro.length >= 1) {
        //     queryGet.produto = JSON.stringify(this.filtros.pro)
        //   }

        //   // SETA O FILTRO CONTATO
        //   queryGet.cliente = '["t"]'
        //   if (this.filtros.con.length >= 1) {
        //     queryGet.cliente = JSON.stringify(this.filtros.con)
        //   }

        //   // SETA O FILTRO VEICULO
        //   queryGet.veiculo = '["t"]'
        //   if (this.filtros.vei.length >= 1) {
        //     queryGet.veiculo = JSON.stringify(this.filtros.vei)
        //   }

        //   // SETA O FILTRO VEICULO
        //   queryGet.pet = '["t"]'
        //   if (this.filtros.pet.length >= 1) {
        //     queryGet.pet = JSON.stringify(this.filtros.pet)
        //   }

        //   // SETA O FILTRO PARA PERIODO
        //   if (this.filtros.dat === '' || this.filtros.dat.id === '') {
        //     queryGet.periodo = 'todos'
        //   } else {
        //     queryGet.periodo = 'personalizado'
        //     queryGet.periodo_per1 = this.filtros.dat.dataIni
        //     queryGet.periodo_per2 = this.filtros.dat.dataFim
        //   }

        //   // FAZ A BUSCA DOS DADOS NA API
        //   this.$store.state.comunicaAPI('/produto/relatorio/lucro-bruto', 'POST', queryGet, (retorno) => {
        //     // INICIA A VARIAVEL
        //     this.linhas = []

        //     // VERIFICA SE TEM REGISTRO
        //     if ([ '', null, undefined ].indexOf(retorno.data) === -1) {
        //       // TRATA OS VALORES
        //       for (var key in retorno.data) {
        //         // INICIA A VARIAVEL
        //         var mensagem = ''
  
        //         // ADICIONA O SIMBOLO DE PORCENTAGEM
        //         retorno.data[key]._markup_por = retorno.data[key].markup_por
        //         if (retorno.data[key].markup_por !== '---') {
        //           retorno.data[key]._markup_por += '%'
        //         }

        //         // FORMATA A QUANTIDADE
        //         retorno.data[key]._qtde_vendida = this.$store.state.FUN_MASK_VALOR('valorDecimal', retorno.data[key].qtde_vendida)
        //         retorno.data[key]._custo_total = this.$store.state.FUN_MASK_VALOR('valorMoeda', (Number(retorno.data[key].custo_total) * 100).toFixed(0))
  
        //         // SETA OS VALORES
        //         if (Number(retorno.data[key].markup_por) < 0) {
        //           mensagem += '<span style="color: red; font-weight: bold;">' + retorno.data[key].lucro_bruto + '</span>'
        //           mensagem += '<br/>'
        //           mensagem += '<span style="color: red; font-weight: bold;">' + retorno.data[key]._markup_por + '</span>'
        //         } else {
        //           mensagem += retorno.data[key].lucro_bruto
        //           mensagem += '<br/>'
        //           mensagem += retorno.data[key]._markup_por
        //         }
  
        //         // SETA O VALO ENCONTRADO
        //         retorno.data[key]._lucro_bruto = mensagem
        //       }

        //       // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
        //       var tabper = this.$store.state.mPer[this.mPer]

        //       // REALIZA A ORDENAÇÃO
        //       switch (tabper.order) {
        //         case '':
        //         case 0:
        //         case '0': // Código Ordem Crescente
        //           retorno.data = retorno.data.sort((a, b) => {
        //             return a.id_pro_codigo < b.id_pro_codigo ? -1 : a.id_pro_codigo > b.id_pro_codigo ? 1 : 0
        //           })
        //           break
                
        //         case 1:
        //         case '1': // Código Ordem Crescente
        //           retorno.data = retorno.data.sort((a, b) => {
        //             return a.id_pro_codigo > b.id_pro_codigo ? -1 : a.id_pro_codigo < b.id_pro_codigo ? 1 : 0
        //           })
        //           break
  
        //         case 2:
        //         case '2': // Código Ordem Crescente
        //           retorno.data = retorno.data.sort((a, b) => {
        //             return a.id_pro_nome < b.id_pro_nome ? -1 : a.id_pro_nome > b.id_pro_nome ? 1 : 0
        //           })
        //           break
        //       }

        //       // SETA OS DADOS DA TABELA
        //       this.linhas = retorno.data

        //       // VERIFICA SE TEM TOTAL PARA INSERIR
        //       if ([ '', null, undefined ].indexOf(retorno.total) === -1) {
        //         // SETA O FLAG TOTAL
        //         retorno.total.flagTotal = true

        //         // ADICIONA O SIMBOLO DE PORCENTAGEM
        //         retorno.total._markup_por = retorno.total.markup_por
        //         if (retorno.total.markup_por !== '---') {
        //           retorno.total._markup_por += '%'
        //         }
                
        //         // SETA O TITULO
        //         retorno.total._qtde_vendida = '<div style="text-align: right; padding-right: 2px;"><b>Total:</b></div>'

        //         // SETA O NOME DA CLASS QUE DEVE UTILIZAR
        //         retorno.total._fundoN = 'linha-total'

        //         // SETA O CUSTO RECEBIDO
        //         retorno.total._custo_total = retorno.total.custo_total

        //         // ADICIONANDO A LINHA
        //         this.linhas.push(retorno.total)
        //       }              
        //     }
            
        //     // SETA O STATUS DE CARREGANDO
        //     this.pesquisa = ''

        //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //     this.time = new Date().getTime()
        //   }, this.proRelLucroBrutoSetarStatusGeral)
        // }
      },
      proRelLucroBrutoAbrirCadastro: function (id) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === true) {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { editar: false, tipo: 'produto', id: id }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.proRelLucroBrutoPesquisar()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      proRelLucroBrutoSetarTotais: function (linhas, callback, retorno) {
        // SETA OS VALORES TOTAIS RECEBIDOS
        this.totais = [ '', null, undefined ].indexOf(retorno.total) === -1 ? retorno.total : null

        // EXECUTA O CALLBACK SOLICITADO
        callback(linhas)
      },
      proRelLucroBrutoSetarLinhas: function (vetor) {

        if(vetor === null || vetor[0] === undefined)
          return;

        // SETA OS CAMPOS QUE DEVE FORMATAR PARA CADA VALOR
        var formatar = {
        //   qtde_min: 'VALOR_DECIMAL_FRONT',
        //   estoque_ajuste: 'VALOR_DECIMAL_FRONT',
        //   comprado: 'VALOR_DECIMAL_FRONT',
        //   dem_dev_cliente: 'VALOR_DECIMAL_FRONT',
        //   fabricado_na_fabricacao: 'VALOR_DECIMAL_FRONT',
        //   fabricado_na_venda: 'VALOR_DECIMAL_FRONT',
        //   fabricado: 'VALOR_DECIMAL_FRONT',
        //   consumido_na_fabricacao: 'VALOR_DECIMAL_FRONT',
        //   consumido_na_venda: 'VALOR_DECIMAL_FRONT',
        //   consumido: 'VALOR_DECIMAL_FRONT',
        //   vendido: 'VALOR_DECIMAL_FRONT',
        //   dem_dev_fornecedor: 'VALOR_DECIMAL_FRONT',
        //   estoque: 'VALOR_DECIMAL_FRONT',
          custo_total: 'VALOR_DECIMAL_FRONT',
        //   venda_total: 'VALOR_DECIMAL_FRONT',
        //   lucro_bruto_valor: 'VALOR_DECIMAL_FRONT',
        //   lucro_bruto_porcentagem: 'VALOR_DECIMAL_FRONT',
        //   valor_for: 'VALOR_DECIMAL_FRONT',
        //   valor_ven: 'VALOR_DECIMAL_FRONT',
          qtde_vendida: 'VALOR_DECIMAL_FRONT',
        }

        // // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
        //   // SETA O BACKUP DA VARIAVEL
        //   vetor[index]._backup = JSON.parse(JSON.stringify(vetor[index]))

        //   // VERIFICA SE O CALCULO DE ESTOQUE TA ATIVADO
        //   if (vetor[index].est_calc !== '1') {
        //     vetor[index] = Object.assign(vetor[index], {
        //       qtde_min: '---',
        //       estoque_ajuste: '---',
        //       comprado: '---',
        //       dem_dev_cliente: '---',
        //       fabricado_na_fabricacao: '---',
        //       fabricado_na_venda: '---',
        //       fabricado: '---',
        //       consumido_na_fabricacao: '---',
        //       consumido_na_venda: '---',
        //       consumido: '---',
        //       vendido: '---',
        //       dem_dev_fornecedor: '---',
        //       estoque: '---',
        //       custo_total: '---',
        //       venda_total: '---',
        //       lucro_bruto_valor: '---',
        //       lucro_bruto_porcentagem: '---'
        //     })
        //   }

        //   // FORMATA OS VALORES RECEBIDOS
          for (var indexF in formatar) {
            vetor[index]['_' + indexF] = ([ '', null, undefined, '---' ].indexOf(vetor[index][indexF]) === -1) ? this.$store.state.FUN_MASCARA_VALOR(formatar[indexF], vetor[index][indexF]) : '---'
          }

        //   // SETA OS VALORES DOS CAMPOS, APÓS ALTERAÇÃO DE NOME DOS CAMPOS NA API
        //   if (vetor[index].estoque_ajuste !== undefined) {
        //     vetor[index].inicio = vetor[index].estoque_ajuste
        //     vetor[index]._inicio = vetor[index]._estoque_ajuste
        //   }

        //   // PINTA O CAMPO DO ESTOQUE EM VERMELHO SE ELE FOR MENOR OU IGUAL A ZERO
        //   if ([ '', null, undefined, '---' ].indexOf(vetor[index].estoque) === -1) {
        //     vetor[index]._estoque = '<span style="' + (Number(vetor[index].estoque) <= 0 ? 'color: red;': '') + ' font-size: var(--font-base-soma-14); font-weight: bold;">' + vetor[index]._estoque + '</span>'
        //   }

          vetor[index]._markup_por = vetor[index].markup_por
          if (vetor[index].markup_por !== '---') {
            vetor[index]._markup_por += '%'
          }
        }


        // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
        // var tabper = this.$store.state.mPer[this.mPer]

        // REALIZA A ORDENAÇÃO
        //20/12/2023 A ordenação passa a ser feita na API devido as exportações de dados
        // switch (tabper.order) {
        //   case '':
        //   case 0:
        //   case '0': // Código Ordem Crescente
        //     vetor = vetor.sort((a, b) => {
        //       return a.id_pro_codigo < b.id_pro_codigo ? -1 : a.id_pro_codigo > b.id_pro_codigo ? 1 : 0
        //     })
        //     break
          
        //   case 1:
        //   case '1': // Código Ordem Crescente
        //     vetor = vetor.sort((a, b) => {
        //       return a.id_pro_codigo > b.id_pro_codigo ? -1 : a.id_pro_codigo < b.id_pro_codigo ? 1 : 0
        //     })
        //     break

        //   case 2:
        //   case '2': // Código Ordem Crescente
        //     vetor = vetor.sort((a, b) => {
        //       return a.id_pro_nome < b.id_pro_nome ? -1 : a.id_pro_nome > b.id_pro_nome ? 1 : 0
        //     })
        //     break
        // }

         // // SETA AS LINHAS NA TELA
        this.linhas = vetor

        // SETA OS DADOS DA TABELA
        // this.linhas = retorno.data

        // VERIFICA SE TEM TOTAL PARA INSERIR
        if ([ '', null, undefined ].indexOf(this.totais) === -1) {
          // SETA O FLAG TOTAL
          this.totais.flagTotal = true

          // ADICIONA O SIMBOLO DE PORCENTAGEM
          this.totais._markup_por = this.totais.markup_por
          if (this.totais.markup_por !== '---') {
            this.totais._markup_por += '%'
          }
          
          // SETA O TITULO
          this.totais._qtde_vendida = '<div style="text-align: right; padding-right: 2px;"><b>Total:</b></div>'

          // SETA O NOME DA CLASS QUE DEVE UTILIZAR
          this.totais._fundoN = 'linha-total'

          // SETA O CUSTO RECEBIDO
          this.totais._custo_total = this.totais.custo_total

          // ADICIONANDO A LINHA
          this.linhas.push(this.totais)
        }

        // // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO NA TELA
        // this.proRelEstMontarGrafico()

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TABELA
        this.proRelLucroBrutoSetarStatusTabela('')
      },
    },
    computed: {
      demRelPorContatoContarColunasLinha1: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 1

        // VERIFICA SE TEM O PACOTE VEICULO
        qtde = (qtde + (this.permissoes.vei === true ? 1 : 0))

        // VERIFICA SE TEM O PACOTE PET
        qtde = (qtde + (this.permissoes.pet === true ? 1 : 0))

        // RETORNA O VALOR
        return qtde
      }
    }
  }
</script>
